import { useQuery } from '@apollo/client';
import { GET_MESSAGES } from './ticketsMessages.Queries';
import { SupportMessagesVariables } from '../../__generated_rental__/SupportMessages';

export function useMessagesQuery(variables: SupportMessagesVariables) {
  return useQuery(GET_MESSAGES, { variables, fetchPolicy: 'network-only' });
}
